import axios from 'axios'
import config from '@/config/index'
axios.defaults.baseURL = config.host
axios.interceptors.response.use(function (response) {
  if (response.data.code == 2720) {
    alert('登陆已过期，请重新登陆')
    removeCookie('token')
    removeCookie('userTel')
    window.location.href = '/login'
    return
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});
let getCookie = (name) => {
  if (document.location.host == 'opentw.ainirobot.com') {
      name = name + '_tw'
  }
  let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
  if(arr=document.cookie.match(reg)) {
    return arr[2]
  } else {
    return null;
  }
}
let removeCookie = (name)=> {
    let flag = false
    if (document.location.host == 'opentw.ainirobot.com') {
        name = name + '_tw'
        flag = true
    }
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = null;
    if (flag) {
        let str = name.slice(0, -3)
        cval = this.getCookie(str);
        
    } else {
        cval = this.getCookie(name);
    }
  if (cval != null) {
    if (document.location.host == 'open.ainirobot.com' || document.location.host == 'opentw.ainirobot.com') {
      document.cookie = name + "="+ cval + ";expires=" + exp.toGMTString() +";domain=.ainirobot.com"
    } else {
      document.cookie = name + "="+ cval + ";expires=" + exp.toGMTString()
    }
  }

}
// 创建产品
export let createProApi = (data) => {
  return axios.post('/hardware/create_client', data)
}
// 产品列表
export let proListApi = (data) => {
  return axios.post('/hardware/client_list', data)
}
// 删除产品
export let deleteProApi = (data) => {
  return axios.post('/hardware/delete_client', data)
}
//客户端名称检查
export let checkProApi = (data) => {
  return axios.post('/hardware/client_name_check', data)
}
// 所有技能
export let skillLApi = (data) => {
  return axios.post('/hardware/skill_list', data)
}
// 搜索所有技能
export let searchSkillLApi = (data) => {
  return axios.post('/hardware/search_all_skill', data)
}
// 私有技能
export let myskillLApi = (data) => {
  return axios.post('/hardware/private_list', data)
}
// 我添加的技能
export let myaddskillLApi = (data) => {
  return axios.post('/hardware/my_skill_list', data)
}
// 技能引用
export let invokeSkillApi = (data) => {
  return axios.post('/hardware/invoke_skill', data)
}
// 取消技能引用
export let invokeSkillDeleteApi = (data) => {
  return axios.post('/hardware/invoke_skill_delete', data)
}
// 获取产品信息
export let proInfoApi = (data) => {
  return axios.post('/hardware/client_info', data)
}
// 编辑产品信息
export let updateClientApi = (data) => {
  return axios.post('/hardware/update_client', data)
}
// license信息
export let licenseInfoApi = (data) => {
    return axios.post('/hardware/userLicenceInfo', data, {headers:{'Content-Type': 'application/json'}})
}
// license下载
export let licenseDownloadApi = (data) => {
    return axios.post('/hardware/userLicenceDownload', data, {headers:{'Content-Type': 'application/json'}})
}
// license提交申请
export let licenseSubApi = (data) => {
    return axios.post('/hardware/userLicenceApplication', data, {headers:{'Content-Type': 'application/json'}})
}
// QA单条保存
export let qaSave = (data) => {
    return axios.post('/skills/qaSave', data, {headers:{'Content-Type': 'application/json'}})
}

// QA单条删除
export let qaDelete = (data) => {
    return axios.post('/skills/qaDelete', data, {headers:{'Content-Type': 'application/json'}})
}
// QA同步
export let qaSync = (data) => {
    return axios.post('/skills/qaSync', data, {headers:{'Content-Type': 'application/json'}})
}
// QA列表
export let qaList = (data) => {
    return axios.post('/skills/qaList', data, {headers:{'Content-Type': 'application/json'}})
}
// QA导入文件
export let qaFileImport = (data) => {
    return axios.post('/skills/qaImport', data, {headers:{'Content-Type': 'application/json'}})
}


// WEBPACK FOOTER //
// ./src/api/hardIndex.js